import React from 'react';
import { get } from 'lodash';
import OptionConflictWithUserSelection from './OptionConflictWithUserSelection';
import OptionConflictConfirmation from './OptionConflictConfirmation';

const OptionConflictModalContent = (props) => {
  const {
    selection,
    option,
    conflictConfig,
    hidePrice,
    onChange,
    modelInfo,
    priceContainer,
  } = props;

  const userSelectionOptions = get(
    conflictConfig,
    'config.toggleCheck.userChoiceOptions',
    []
  );

  const requiresUserSelection = userSelectionOptions.length > 0;

  return (
    <div className="toggle-option-conflict">
      {requiresUserSelection ? (
        <OptionConflictWithUserSelection
          option={option}
          conflictConfig={conflictConfig}
          hidePrice={hidePrice}
          selection={selection}
          onChange={onChange}
        />
      ) : (
        <OptionConflictConfirmation
          option={option}
          conflictConfig={conflictConfig}
          modelInfo={modelInfo}
          priceContainer={priceContainer}
        />
      )}
    </div>
  );
};

export default OptionConflictModalContent;
